import React from 'react'
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import Divider from '@mui/material/Divider';
import ListItemText from '@mui/material/ListItemText';
import { styled } from '@mui/material/styles';
import { FaCheckSquare } from "react-icons/fa";


const StyledListItem = styled(ListItem)(({ theme }) => ({
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
    borderRadius: theme.shape.borderRadius,
  },
  padding: theme.spacing(1, 2),
  transition: 'background-color 0.3s ease',
}));

const UVPrinting = () => {
  return (
    <>
    <title>UV Printing</title>
<article className='pt-8 max-w-[1200px] mx-auto px-8'>
      <h1 className='text-2xl font-bold pb-4'>UV Printing: Innovation Meets Excellence</h1>

      <p>UV printing is a cutting-edge technology that revolutionizes print quality with vibrant colors, exceptional durability, and unmatched versatility. By utilizing ultraviolet light curing, this advanced method ensures sharp, high-resolution prints on a wide range of surfaces—including non-porous materials like glass, metal, acrylic, and plastics. Unlike traditional printing, UV printing delivers instant drying, zero ink bleed, and superior resistance to scratches, fading, and moisture. With the ability to print up to 3 mm in thickness, a vast spectrum of hundreds of colors, and stunning 3D metallic effects, this technology brings designs to life with striking brilliance and texture.</p>
    
    <h2 className='text-xl font-bold py-4'>Elevate Your Brand with Premium UV-Printed Products</h2>

    <p>At Gutenberg Solution, we specialize in high-end UV printing that transforms ordinary products into luxury-branded masterpieces. Our unique printing mix blends transparent inks with gold and silver luster, creating captivating designs on glass, porcelain, stainless steel, and metal surfaces. Whether for corporate gifts, promotional items, or retail packaging, our prints enhance the weight, appearance, and perceived value of your products—making them more marketable and visually appealing.</p>
    

    <h2 className='text-xl font-bold py-4'>Why Choose Gutenberg Solution?</h2>


     <section>
      <List dense>
        <StyledListItem>
          <ListItemText
            primary={
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <FaCheckSquare size={34} style={{color: '#1D4E89'}}/>
                <strong>Rapid customization:</strong> Tailored designs to match your brand identity.
            </div>
           }
          />
        </StyledListItem>
        <div><Divider/></div>
        <StyledListItem>
          <ListItemText
            primary={
           <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <FaCheckSquare size={34} style={{color: '#1D4E89'}}/>
            <strong>Fast production:</strong> Efficient workflows for quick turnaround times.
            </div>
            }
          />
        </StyledListItem>
        <div><Divider/></div>
        <StyledListItem>
          <ListItemText
            primary={
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <FaCheckSquare size={34} style={{color: '#1D4E89'}}/>
            <strong>Precision color matching:</strong> Consistent, high-definition results.
            </div>
        }
          />
        </StyledListItem>
        <div><Divider/></div>
        <StyledListItem>
          <ListItemText
            primary={
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <FaCheckSquare size={34} style={{color: '#1D4E89'}}/>
            <strong>Uncompromising durability:</strong> Long-lasting prints that withstand wear.
            </div>
        }
          />
        </StyledListItem>

                <div><Divider/></div>
        <StyledListItem>
          <ListItemText
            primary={
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <FaCheckSquare size={34} style={{color: '#1D4E89'}}/>
            <strong>On-time delivery:</strong> Reliable service to meet your deadlines.
            </div>
        }
          />
        </StyledListItem>

      </List>
        
       
      </section>

      <section className='py-4'>
        <p>With state-of-the-art UV printing technology and a commitment to innovation and quality, Gutenberg Solution ensures your products stand out in the market. Partner with us to bring your boldest branding visions to reality!</p>
      </section>


    </article>
    </>
  )
}

export default UVPrinting
